import { usePaging } from "hooks/usePaging";
import { useGetTicketSamplesActiveQuery } from "services";
import { FindAllTicketSampleActiveDto } from "types";
import { DEFAULT_PAGE_SIZE } from "utils";
const pageSize = DEFAULT_PAGE_SIZE;
export function useTicketSampleActive(params: Omit<FindAllTicketSampleActiveDto, 'pageIndex' | 'pageSize'>) {
    const { hotkey, serviceTypeId } = params;
    const { pageIndex, changePage, resetPage } = usePaging(params);
    const {
        data: ticketSampleActiveResponse,
        error,
        isLoading,
        isFetching
    } = useGetTicketSamplesActiveQuery({
        pageIndex: pageIndex,
        pageSize,
        hotkey,
        serviceTypeId,
    });
    const handleChangePage = changePage;

    return {
        ticketSampleActive: (() => {
            try {
                if (!ticketSampleActiveResponse?.data?.rows) return [];

                // Create a copy to avoid mutating the original array
                const sorted = [...ticketSampleActiveResponse.data.rows].sort((a, b) => {
                    try {
                        // Extract numbers from the title for natural sorting
                        const getNumericPart = (str: string = '') => {
                            const num = str.match(/\d+/);
                            return num ? parseInt(num[0], 10) : 0;
                        };

                        const numA = getNumericPart(a?.title);
                        const numB = getNumericPart(b?.title);

                        // If both titles contain numbers, compare them numerically
                        if (numA !== 0 && numB !== 0) {
                            return numA - numB;
                        }
                        // Otherwise, fall back to string comparison
                        return (a?.title || '').localeCompare(b?.title || '');
                    } catch (error) {
                        console.error('Error sorting ticket samples:', error);
                        return 0; // Keep original order if comparison fails
                    }
                });

                return sorted;
            } catch (error) {
                console.error('Error processing ticket samples:', error);
                // Return original data if any error occurs during processing
                return ticketSampleActiveResponse?.data?.rows || [];
            }
        })(),
        count: ticketSampleActiveResponse?.data?.count || 0,
        pageIndex,
        isLoading: isFetching || isLoading,
        error,
        handleChangePage,
        resetPage
    };
}